<script>
    // imports
    import Heading from '../shared/Heading.svelte';
    import Buttons from '../shared/Buttons.svelte';
    import Image from '../shared/Image.svelte';
    import Cards from '../shared/Cards.svelte';
    import FeaturedPhoto from '../shared/FeaturedPhoto.svelte';
    import Section from '../shared/Section.svelte';
    import Text from '../shared/Text.svelte';
    import Video from '../shared/Video.svelte';

    // exports
    export let entries;
</script>

<div>
    {#each entries as entry}

        <!-- Section -->
        {#if entry.blockType === 'pageSection'}
            <Section data={entry}>
                
                {#each entry.blocks as block}
                    <!-- {console.log({block})} -->

                    <!-- Organism: Cards -->
                    {#if block.blockType === 'imageCards'}
                        <Cards entries={block} />

                    <!-- Organism: Photo Feature -->
                    {:else if block.blockType === 'featuredPhoto'}
                        <FeaturedPhoto data={block} />

                    <!-- Atom: Heading -->
                    {:else if block.blockType === 'heading'}
                        <Heading data={block} parallax={entry.blockParallax} />

                    <!-- Atom: Text -->
                    {:else if block.blockType === 'text'}
                        <Text>
                            {@html block.storageSolutionsText}
                        </Text>

                    <!-- Atom: Asset -->
                    {:else if block.blockType === 'asset'}
                        {#if block.storageSolutionsAsset[0].asset[0].kind === 'image'}
                            <Image imageData={block.storageSolutionsAsset[0].asset[0].optimizedImagesPhotoFeature} />
                        {:else}
                            <Video 
                                url={block.storageSolutionsAsset[0].asset[0].url} 
                                mime={block.storageSolutionsAsset[0].asset[0].mimeType}
                                data={block} 
                                poster={block.storageSolutionsAsset[0].asset[0].storageSolutionsVideoPlaceholderImage.length > 0 ? block.storageSolutionsAsset[0].asset[0].storageSolutionsVideoPlaceholderImage[0].url : ''}
                            />
                        {/if}


                        <!-- Atom: Button -->
                    {:else if block.blockType === 'button'}
                        <Buttons data={block} />

                    <!-- Atom: Icons -->
                    {:else if block.blockType === 'icons'}
                        <!-- TODO: Add Icons block <Icons data={block} /> -->
                    {/if}

                {/each}

            </Section>
        {/if}
    {/each}
</div>